import React from 'react';
import { blogs } from '../../data/blog';
import { Link } from 'react-router-dom'; // import Link for navigation

function Blog() {
  // Sort blogs by date in descending order and take the last two
  const latestBlogs = blogs.slice(-2);

  return (
    <div className='section section-padding'>
      <div className='container'>
        <div className='blog-wrapper'>
          <div className='row'>
            {/* Sidebar / Title */}
            <div className='col-lg-4' data-aos='fade-up' data-aos-delay={200}>
              <div className='blog-sidebar-title'>
                <div className='section-title'>
                  <h6 className='sub-title'>Blog</h6>
                  <h2 className='title'>
                    Latest Post <br />
                    from Blog
                    <img
                      className='shape'
                      src='assets/images/shape/shape-15.webp'
                      alt='Shape'
                    />
                  </h2>
                </div>
              </div>
            </div>

            {/* Blog Posts */}
            {latestBlogs.map((blog, index) => (
              <div
                key={index}
                className='col-lg-4 col-md-6'
                data-aos='fade-up'
                data-aos-delay={200 + index * 200} // stagger animation
              >
                <Link
                  to={`/blog/${blog.slug}`}
                  className='text-decoration-none'
                >
                  <div className='single-blog'>
                    <div className='blgo-image'>
                      <img
                        src={blog.image}
                        width={314}
                        height={238}
                        alt={blog.title}
                        className='img-fluid'
                      />
                    </div>
                    <div className='blgo-content'>
                      <ul className='meta'>
                        <li>
                          <i className='fa fa-calendar' />{' '}
                          {new Date(blog.date).toLocaleDateString('en-US', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })}
                        </li>
                      </ul>
                      <h3 className=''>{blog.title}</h3>
                    </div>
                    <img
                      src='assets/images/shape/shape-4.webp'
                      className='shape'
                      alt='Shape'
                    />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
        {/* Blog Wrapper End */}
      </div>
    </div>
  );
}

export default Blog;
